import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '../../contexts/OrganizationContext';
import { createInspectionService } from '../services/inspection.service';
import { InspectionDto } from '../types/dtos/inspection';
import { CustomResponseEntity } from '../types/common';

export const useInspections = () => {
  const { selectedOrganization } = useOrganization();

  return useQuery<CustomResponseEntity<InspectionDto[]>, Error>({
    queryKey: ['inspections', selectedOrganization?.id],
    queryFn: async () => {
      if (!selectedOrganization?.id) {
        throw new Error('Organization ID is required');
      }
      const service = createInspectionService(selectedOrganization.id);
      return service.findAll();
    },
    enabled: !!selectedOrganization?.id,
    staleTime: 30000,
    refetchOnWindowFocus: false
  });
}; 